import React from 'react'
import { IntlProvider } from 'react-intl'

import type { WrapperProps } from '~/components/@types'

import type { Locale } from './@types'
import { useMessages } from './useMessages'

type IntlProps = WrapperProps & {
  locale?: Locale
}

const Intl: React.FC<IntlProps> = ({ children, locale = 'en-US' }) => {
  const { data } = useMessages(locale)

  return (
    <IntlProvider messages={data} locale={locale}>
      {children}
    </IntlProvider>
  )
}

export default Intl
